<div
  id="sign-widget-parent"
  class="widget"
></div>
